import {
  MRT_GlobalFilterTextField,
  MaterialReactTable,
  type MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { Box, Button, lighten, Stack } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import InstitutionsImage from '../icons/InstitutionsImage';

const columns = [
  {
    size: 20,
    accessorKey: 'rank',
    header: 'rank',
  },
  {
    size: 20,
    header: 'foto',
    Cell: ({ renderedCellValue }) => {
      return (
        <Box>
          <InstitutionsImage sx={{ fontSize: '40px' }} />
        </Box>
      );
    },
  },
  {
    size: 20,
    accessorKey: 'institution',
    header: 'Institu...',
  },
  {
    size: 20,
    accessorKey: 'notes',
    header: 'Notas',
    Cell: ({ renderedCellValue }) => {
      return (
        <Box sx={{color: '#09238E', fontWeight: 'bold'}}>
          {renderedCellValue}
        </Box>
      );
    },
  },
  {
    size: 20,
    accessorKey: 'result',
    header: 'resul...',
    Cell: ({ renderedCellValue }) => {
      return (
        <Box sx={{color: '#09238E', fontWeight: 'bold'}}>
          {renderedCellValue}
        </Box>
      );
    },
  },
  {
    accessorKey: 'id',
    header: 'ID',
    enableHiding: true,
    enableSorting: false,
    enableResizing: false,
    size: 0,
  },
];

const data = [
  {
    rank: 1,
    institution: 'Rodrigo costa',
    notes: '00',
    result: 5,
    id: '123',
  },
  {
    rank: 1,
    institution: 'Rodrigo costa',
    notes: '00',
    result: 5,
    id: '123',
  },
];

const TableBasicRankRaioInstitutions = () => {
  const navigate = useNavigate();
  const tableBasic = useMaterialReactTable({
    columns,
    data,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    // enablePagination: false,
    enableRowActions: false,
    enableRowSelection: true,
    enableBottomToolbar: false,
    initialState: {
      showGlobalFilter: false,
      columnVisibility: {
        id: false,
      },
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        backgroundColor: '#F7F7F7',
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: ({ column }) => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    renderTopToolbar: ({ table }) => {
      const handleDeactivate = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('deactivating ' + row.getValue('name'));
        });
      };

      const handleActivate = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('activating ' + row.getValue('name'));
        });
      };

      const handleContact = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('contact ' + row.getValue('name'));
        });
      };

      return (
        <Box
          sx={(theme) => ({
            backgroundColor: lighten(theme.palette.background.default, 0.05),
            display: 'none',
            gap: '0.5rem',
            p: '8px',
            justifyContent: 'space-between',
            border: '1px solid red',
          })}
        >
          <Box sx={{ borderRadius: '20px' }}>
            <MRT_GlobalFilterTextField table={table} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                color="error"
                disabled={!tableBasic.getIsSomeRowsSelected()}
                onClick={handleDeactivate}
                variant="contained"
              >
                Deactivate
              </Button>
              <Button
                color="success"
                disabled={!table.getIsSomeRowsSelected()}
                onClick={handleActivate}
                variant="contained"
              >
                Activate
              </Button>
              <Button
                color="info"
                disabled={!table.getIsSomeRowsSelected()}
                onClick={handleContact}
                variant="contained"
              >
                Contact
              </Button>
            </Box>
          </Box>
        </Box>
      );
    },
    // renderRowActions: ({ row }) => {
    //   const studentId = data[row.index].id;
    //   const nameStudent = data[row.index]. aluno;

    //   return (
    //     <Stack alignItems={'center'}>
    //       <RemoveRedEye
    //         sx={{
    //           cursor: 'pointer',
    //         }}
    //         onClick={() => navigate('/raiox-termometro-alunos', { state: { id: studentId, name: nameStudent } })}
    //       />
    //     </Stack>
    //   );
    // },
  });

  return (
    <>
      <MaterialReactTable table={tableBasic} />
    </>
  );
};

export default TableBasicRankRaioInstitutions;
